export const appendScriptPromise = (scriptUrl, scriptId) => {
  if (!document.getElementById(scriptId)) {
    const script = document.createElement('script')
    script.src = scriptUrl
    if (scriptId) script.id = scriptId
    document.body.appendChild(script)

    return new Promise((resolve, reject) => {
      script.onload = function () {
        resolve()
      }
      script.onerror = function () {
        reject(new Error('Script could not be added'))
      }
    })
  }
}
